import React, { useEffect, useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Form, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import AxiosInstance from '../AxiosInstance';
import ELayout from './ELayout';
import ToastNotification from '../ToastNotification';
import { ArrowLeftCircle } from 'react-bootstrap-icons';

const WFHHistory = () => {
  const [wfhHistory, setWFHHistory] = useState([]);
  const toastRef = useRef();
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const employeeId = localStorage.getItem('employeeId');

  useEffect(() => {
    if (employeeId) {
      AxiosInstance.get('/employee/wfh-history', {
        params: { employee_id: employeeId },
      })
        .then((res) => setWFHHistory(res.data))
        .catch(() =>
          toastRef.current?.showToast('Error fetching WFH history', 'danger')
        );
    }
  }, [employeeId]);

  const formatDate = (value) => {
    return new Date(value).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const statusBodyTemplate = (rowData) => {
    const status = rowData.status?.toLowerCase();
    let severity = 'info';
    if (status === 'accepted') severity = 'success';
    else if (status === 'rejected') severity = 'danger';
    else if (status === 'pending') severity = 'warning';

    return <Tag value={rowData.status} severity={severity}></Tag>;
  };

  const capitalizeWords = (text) =>
    text
      ?.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
const handleFilter = () => {
  if (!fromDate || !toDate) return;

  AxiosInstance.get('/employee/wfh-history', {
    params: {
      employee_id: employeeId,
      from: fromDate,
      to: toDate,
    },
  })
    .then((res) => {
      setWFHHistory(res.data);
      if (res.data.length === 0) {
        toastRef.current?.showToast('No records found for selected range', 'info');
      }
    })
    .catch(() =>
      toastRef.current?.showToast('Error filtering WFH history', 'danger')
    );
};

  const handleReset = () => {
    setFromDate(null);
    setToDate(null);

    if (employeeId) {
      AxiosInstance.get('/employee/wfh-history', {
        params: { employee_id: employeeId },
      })
        .then((res) => setWFHHistory(res.data))
        .catch(() =>
          toastRef.current?.showToast('Error resetting WFH history', 'danger')
        );
    }
  };

  return (
    <ELayout
      heading={
        <div className="mb-3 d-flex align-items-center">
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
          <span className="ms-3">WFH History</span>
        </div>
      }
    >
      <div className="card p-3">
        <Form className="mb-3 d-flex gap-2 align-items-end flex-wrap">
          <Form.Group controlId="fromDate">
            <Form.Label>From</Form.Label>
            <Form.Control
              type="date"
              value={fromDate || ""}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="toDate">
            <Form.Label>To</Form.Label>
            <Form.Control
              type="date"
              value={toDate || ""}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>

          <Button
            variant="primary"
            onClick={handleFilter}
            disabled={!fromDate || !toDate}
          >
            Filter
          </Button>

          <Button
            variant="secondary"
            onClick={handleReset}
            disabled={!fromDate && !toDate}
          >
            Reset
          </Button>
        </Form>

        <DataTable
          value={wfhHistory}
          paginator
          rows={10}
          stripedRows
          showGridlines
          scrollable
          responsiveLayout="scroll"
          emptyMessage="No WFH history found"
        >
          <Column field="start_date" header="Start Date" body={(row) => formatDate(row.start_date)} sortable />
          <Column field="end_date" header="End Date" body={(row) => formatDate(row.end_date)} sortable />
          <Column field="reason" header="Reason" body={(row) => capitalizeWords(row.reason)} sortable />
          <Column field="status" header="Status" body={statusBodyTemplate} sortable />
          <Column field="created_at" header="Requested On" body={(row) => formatDate(row.created_at)} sortable />
        </DataTable>
      </div>
      <ToastNotification ref={toastRef} />
    </ELayout>
  );
};

export default WFHHistory;
